/**
 * client/src/lib/handshake-duties-api.ts
 *
 * The caller's own guardian-DUTY inbox (PR A, Task A3) — every pending,
 * unexpired handshake where THIS user occupies a guardian slot and has not
 * yet responded, across ALL operation types (forensic-pause lift included,
 * but not limited to it).
 *
 * Deliberately a SEPARATE inbox from `guardianships-api.ts`: a guardianship
 * request ("will you be my guardian") and a handshake duty ("someone you
 * already protect needs your approval right now") are different questions —
 * the first is answered by proving knowledge of the ward once, the second
 * recurs for as long as the relationship exists. Folding them into one list
 * would blur that distinction at exactly the moment urgency matters (a
 * handshake duty expires in 30 minutes; a guardianship request does not).
 *
 * Backed by server/routes/forensic-lift-status.routes.ts (Task A1, landed):
 *   GET /api/circle/handshake/pending-duties
 */

import { apiRequest } from "@/lib/queryClient";

export interface PendingHandshakeDuty {
  handshakeId: string;
  operationType: string;
  initiatorDisplayName: string;
  expiresAt: string;
}

export interface PendingHandshakeDutiesResponse {
  duties: PendingHandshakeDuty[];
}

/** Query key shared by the Invitations page section and the push listener's
 *  invalidation on a fresh `handshake:guardian_request` — imported, never
 *  retyped, so the two can never drift out of step. */
export const HANDSHAKE_DUTIES_QUERY_KEY = ["circle", "handshake", "pending-duties"] as const;

export function getPendingHandshakeDuties(): Promise<PendingHandshakeDutiesResponse> {
  return apiRequest<PendingHandshakeDutiesResponse>("/api/circle/handshake/pending-duties");
}
